import * as React from "react";

const useSyncUpdates = () => {
  const [key, setKey] = React.useState(0);

  const triggerSync = React.useCallback(() => {
    setKey((key) => key + 1);
  }, []);

  const sync = (index) => {
    return key + index;
  };

  return { triggerSync, sync };
};

export default useSyncUpdates;
